<script setup lang="ts">
import { FdxDropdown } from '@foodics/ui-common';
import NotificationsCenter from './NotificationsCenter.vue';
import { groupTypesMap, useNotifications } from '@/composables/notifications';

const { hasUnread, isLoadingUnreadCount } = useNotifications({
    filters: { type: groupTypesMap['transactions'] },
});
</script>

<template>
    <FdxDropdown
        placement="bottom-end"
        data-testid="nav-dropdown-notifications"
        :popper-hide-triggers="[]"
        :popper-mobile-view-style="'bottomsheet'"
    >
        <template #trigger>
            <button
                class="relative p-2 rounded-lg hover:bg-gray-100 transition-colors"
                data-testid="nav-button-notifications"
            >
                <FdxIconNotifications
                    class="text-gray-700 size-6"
                    :class="{ 'animate-pulse': isLoadingUnreadCount }"
                />

                <span
                    v-if="hasUnread"
                    class="absolute top-2 end-2 flex size-2.5"
                    data-testid="nav-notifications-badge"
                >
                    <span
                        class="absolute inline-flex size-full animate-ping rounded-full bg-negative-500 opacity-75"
                    />
                    <span
                        class="relative inline-flex size-2.5 rounded-full border-2 border-white bg-negative-500"
                    />
                </span>
            </button>
        </template>
        <template #menu>
            <NotificationsCenter class="w-full md:w-[420px]" />
        </template>
    </FdxDropdown>
</template>
